export const NOT_INITIALIZED = 'NotInitialized';
export const AUTHENTICATNG = 'Authenticating';
export const AUTHENTICATED = 'Authenticated';
export const NOT_AUTHENTICATED = 'NotAuthenticated';
